import React, { useEffect, useLayoutEffect, useMemo } from "react";
import Header from "./header";
import Footer from "./footer";
import SideBar from "./sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { useDispatch, useSelector } from "react-redux";
import GlobalLoader from "./globalLoader";
import { setUserType } from "../../../redux/slices/userType";
import { addData } from "../../../redux/slices/globalDetails";
import * as globalSettings from "../services/globalsetting.services"
import { SOCKET_CLIENT } from "../../../utils/socket";
import { SOCKET_EVENTS } from "../../../utils/Constants";
import Swal from "sweetalert2";

const AdminLayout = () => {
  const dispatch = useDispatch();
  const loaderState = useSelector((state) => state.globalLoader);
  const navigate = useNavigate();
  window.navigate_ = navigate;

  useMemo(() => {
    globalSettings.Details().then((data) => {
      dispatch(addData(data && data.data ? data.data : null));
    }).catch((error) => {
      console.log("error--->", error)
    })
  }, []);

  useEffect(() => {
    const joinAdminRoom = () => {
      SOCKET_CLIENT.emit("join_stream_room", "ADMIN_ROOM");
    };

    if (SOCKET_CLIENT.connected) {
      joinAdminRoom();
    }

    const handleSafetyFlag = (payload) => {
      const streamName = payload?.streamName ? ` "${payload.streamName}"` : "";
      Swal.fire({
        icon: "warning",
        title: "Safety Flag Detected ⚠️",
        text: `A product was flagged for safety issues in the live stream${streamName}.`,
        toast: true,
        position: "top-end",
        timer: 5000,
        showConfirmButton: false,
        timerProgressBar: true,
        customClass: { container: "stream-toast" },
        didOpen: (toast) => {
          const container = toast.closest(".swal2-container");
          if (container) container.style.zIndex = "9999999";
        },
      });
    };

    SOCKET_CLIENT.on("connect", joinAdminRoom);
    SOCKET_CLIENT.on("SAFETY_FLAG_DETECTED", handleSafetyFlag);

    return () => {
      SOCKET_CLIENT.off("connect", joinAdminRoom);
      SOCKET_CLIENT.off("SAFETY_FLAG_DETECTED", handleSafetyFlag);
    };
  }, []);

  useLayoutEffect(() => {
    dispatch(setUserType("admin"));
    Promise.all([
      import("rsuite/dist/rsuite.min.css"),
      import("bootstrap/dist/css/bootstrap.min.css"),
      import("../../../assets/admin/css/skins.css"),
      import("../../../assets/admin/css/icon-list.css"),
      import("../../../assets/admin/plugins/select2/css/select2.min.css"),
      import("../../../assets/admin/css/style.css"),
      import("../../../assets/admin/css/dark-style.css"),
      import("../../../assets/admin/css/colors/default.css"),
      import(
        "../../../assets/admin/plugins/multipleselect/multiple-select.css"
      ),
      import("../../../assets/admin/css/sidemenu/sidemenu.css"),
      import("../../../assets/admin/plugins/summernote/summernote-bs4.css"),
      import("../../../assets/admin/plugins/fileuploads/css/fileupload.css"),
      import("../../../assets/admin/plugins/fancyuploder/fancy_fileupload.css"),
    ]).then(() => {
      dispatch(setGlobalLoader(false));
    });
  }, []);

  return (
    <>
      {loaderState ? (
        <GlobalLoader />
      ) : (
        <div className="page">
          <SideBar />
          <Header />
          <div className="main-content side-content">
            <div className="container-fluid">
              <div className="inner-body">
                <Outlet />
              </div>
            </div>
          </div>
          <a href="#top" id="back-to-top">
            <i className="fe fe-arrow-up"></i>
          </a>
          <Footer />
        </div>
      )}
    </>
  );
};
export default AdminLayout;
